import { render, staticRenderFns } from "./wordCloud.vue?vue&type=template&id=6a8b2c78&scoped=true"
import script from "./wordCloud.vue?vue&type=script&lang=js"
export * from "./wordCloud.vue?vue&type=script&lang=js"
import style0 from "./wordCloud.vue?vue&type=style&index=0&id=6a8b2c78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8b2c78",
  null
  
)

export default component.exports